import { z } from "zod";

import { zSchema as zMetaSchema } from "./meta";

function zSchema<T extends z.ZodSchema>(item: T) {
  return z.object({
    items: z.array(item),
    meta: zMetaSchema,
  });
}

type Schema<T extends z.ZodSchema> = z.infer<ReturnType<typeof zSchema<T>>>;

export { zSchema };
export type { Schema };
